
import required from '../../../vendor/scripts/fabrique/modules/required';

export default class Component {

  constructor(name = required(), element = required(), options = {}) {

    this.name = name;
    this.element = element;
    this.selector = `.${this.name}`;

    this.options = Object.assign({}, {
      onLoad: true,
      onContentLoad: false,
      onDelayedLoad: false,
    }, options);

    if (this.element.instance) {
      return;

    }

    if (this.options.onLoad) {
      window.addEventListener('init-load', this.init.bind(this));
    }

    if (this.options.onContentLoad) {
      window.addEventListener('init-content-load', this.init.bind(this));
    }

    if (this.options.onDelayedLoad) {
      window.addEventListener('init-delayed-load', this.init.bind(this));
    }

    if (this.options.onRightAway) {
      this.init();
    }

    // Disabled: We need to generate a unique hash, or this event will be overwritten when multiple instances.
    // We can also access this instance with element.instance to call init again.
    //window.addEventListener(`reinit-${this.name}`, this.init.bind(this));

    // We return this object to bind the instance.
    return this;
  }

  static init() {
    // Override this method
  }

}



// WEBPACK FOOTER //
// ./website/assets/scripts/modules/component.js